import AnalyticsAdapter from "../core/AnalyticsAdapter";

/**
 * Dev-only destination: logs what would have been sent instead of hitting
 * GA4. Used whenever real tracking is disabled (local dev/test, or GA4 isn't
 * configured yet) so the rest of the app can call useAnalytics() unconditionally.
 */
export default class ConsoleAdapter extends AnalyticsAdapter {
  initialize() {
    // eslint-disable-next-line no-console
    console.info("[analytics] ConsoleAdapter active — no data is sent to GA4.");
  }

  trackPageView(path, title) {
    // eslint-disable-next-line no-console
    console.info("[analytics] page_view", { path, title });
  }

  trackEvent(name, params) {
    // eslint-disable-next-line no-console
    console.info("[analytics] event", name, params);
  }

  setUser(userId) {
    // eslint-disable-next-line no-console
    console.info("[analytics] setUser", userId);
  }

  setUserProperties(properties) {
    // eslint-disable-next-line no-console
    console.info("[analytics] setUserProperties", properties);
  }
}
